import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import { Row, Col } from 'react-bootstrap';
import Breadcrumb from '../../Breadcrumb/Main'
import DeptLeft from '../People/Dept_Left'

const HD = [

    {
        "Name": "Dr. Suresh Jain",
        "NameLink": "/dr-suresh-jain",
        "Position": "Professor",
        "Category": "Head of the Department",
        "Degree": "Ph.D - Indian Institute of Technology Delhi, India",
        "AreasofInterest": "Air quality modeling and management; Environmental risk assessment",
        "Phone": "0877 250 3166",
        "Email": "sureshjain@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/SureshPP.JPG"
    }

   
]
const Faculty = [


  

    {
        "Name": "Dr. K.N. Satyanarayana",
        "NameLink": "https://iittp.ac.in/director",
        "Position": "Professor & Director",
        "Degree": "Ph.D - Clemson University, USA",
        "AreasofInterest": "Construction Project Management",
        "Phone": "0877 250 3163",
        "Email": "director@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/director.jpg"
    },
    
    {
        "Name": "Dr. B. Krishna Prapoorna",
        "NameLink": "https://iittp.ac.in/dr-b-krishna-prapoorna",
        "Position": "Professor",
        "Degree": "Ph.D - Arizona State University, USA ",
        "AreasofInterest": "Transportation Engineering ",
        "Phone": "0877 250 3157 ",
        "Email": "bkp@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/krishna1.jpg"
    },
    {
        "Name": "Dr. A. Murali Krishna",
        "NameLink": "https://iittp.ac.in/dr-a-murali-krishna",
        "Position": "Professor & Dean PI",
        "Degree": "Ph.D - Indian Institute of Science, Bangalore, India",
        "AreasofInterest": "Earthquake Geotechnics",
        "Phone": "0877-250 3168",
        "Email": "amk@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/AMK-NEW.jpg"
    },
    {
        "Name": "Dr. Ramanathan Ayothiraman",
        "NameLink": "https://iittp.ac.in/prof-ramanathan-ayothiraman",
        "Position": "Professor",
        "Degree": "Ph.D - Indian Institute of Technology Madras, India ",
        "AreasofInterest": "Geotechnical Engineering, Rock Engineering ",
        "Phone": "0877 250 XXXX ",
        "Email": "ayothiraman@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Prof_Ramanathan_Ayothiraman.jpg"
    },
    {
        "Name": "Dr. Shihabudheen M. Maliyekkal",
        "NameLink": "/dr-shihabudheen-m-maliyekkal",
        "Position": "Professor",
        "Degree": "Ph.D - Indian Institute of Technology Madras, India",
        "AreasofInterest": "Environmental Engineering",
        "Phone": "0877 250 3164",
        "Email": "shihab@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Shihab.png"
    },
    // {
    //     "Name": "Dr. Suresh Jain",
    //     "NameLink": "/dr-suresh-jain",
    //     "Position": "Professor",
    //     "Degree": "Ph.D - Indian Institute of Technology Delhi, India",
    //     "AreasofInterest": "Air quality modeling and management; Environmental risk assessment",
    //     "Phone": "0877 250 3166",
    //     "Email": "sureshjain@iittp.ac.in",
    //     "Image": "https://files.iittp.ac.in/images/demo/iit/SureshPP.JPG"
    // },
    {
        "Name": "Dr. Gowri Asaithambi",
        "NameLink": "/dr-a-gowri",
        "Position": "Associate Professor",
        "Degree": "Ph.D - Indian Institute of Technology Madras, India",
        "AreasofInterest": "Traffic Flow Modeling and Simulation, Traffic Operations and Management",
        "Phone": "0877 250 3158",
        "Email": "gowri@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/AGowri.jpg"
    },
    {
        "Name": "Dr. B. Janaki Ramaiah",
        "NameLink": "/dr-b-janaki-ramaiah",
        "Position": "Associate Professor",
        "Degree": "Ph.D - Indian Institute of Technology Delhi, India",
        "AreasofInterest": "Geotechnical and Geoenvironmental Engineering",
        "Phone": "0877 250 3159",
        "Email": "janakiram@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/JanakiRamaiah.jpg"
    },

    {
        "Name": "Dr. M. Nithyadharan",
        "NameLink": "/dr-nithyadharan",
        "Position": "Associate Professor",
        "Degree": "Ph.D - Indian Institute of Technology Madras, India",
        "AreasofInterest": "Metal structures and Earthquake resistant design",
        "Phone": "0877 250 3160",
        "Email": "nithyadharan@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Nithyadharan.jpg"
    },

    {
        "Name": "Dr. Prasanna Venkatesh Sampath",
        "NameLink": "/dr-prasanna-venkatesh",
        "Position": "Associate Professor",
        "Degree": "Ph.D - Michigan State University, East Lansing, USA",
        "AreasofInterest": "Water Resources Engineering",
        "Phone": "0877 250 3162",
        "Email": "prasvenk@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/venkatpv.jpg"
    },

    {
        "Name": "Dr. Roshan Srivastav",
        "NameLink": "/dr-roshan-srivastav",
        "Position": "Associate Professor",
        "Degree": "Ph.D - Indian Institute of Technology Madras, India",
        "AreasofInterest": "Water Resources Management, Climate Change, Remote Sensing",
        "Phone": "0877 250 3165",
        "Email": "roshan@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/roshan.jpg"
    },

    

    {
        "Name": "Dr. Avadh Bihari Narayan",
        "NameLink": "https://iittp.ac.in/dr-avadh-bihari-narayan",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology Kanpur, India",
        "AreasofInterest": "Remote sensing, Geodesy",
        "Email": "avadhbn@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Avadh.jpg"
    },
    {
        "Name": "Dr. Bijily Balakrishnan",
        "NameLink": "/dr-bijily-balakrishnan",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology Madras, India",
        "AreasofInterest": "Reinforced concrete design, Prestressed concrete design",
        "Phone": "0877 250 3156",
        "Email": "bijily@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/bijili.jpg"
    },
    

    {
        "Name": "Dr. Jashnav Pancheti",
        "NameLink": "https://iittp.ac.in/dr-jashnav-pancheti",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Queensland University of Technology, Brisbane, Australia",
        "AreasofInterest": "Structural Fire Engineering, Building Fire Safety",
        "Email": "jashnav@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Jashnav_Pancheti_AP.png"
    },

    {
        "Name": "Dr. Lokesh Kumar Kalahasthi",
        "NameLink": "https://iittp.ac.in/dr-lokesh-kumar-kalahasthi",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Rensselaer Polytechnic Institute, Troy, NY, USA",
        "AreasofInterest": "Freight Demand Modeling, Supply Chain and Logistics",
        "Email": "klokesh@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr_Lokesh_Kumar_Kalahasthi_AP.png"
    },
    
    {
        "Name": "Dr. Narasamma Nippatlapalli",
        "NameLink": "https://iittp.ac.in/dr-narasamma-nippatlapalli",
        "Position": "Assistant Professor",
        "Degree": "Postdoc., Florida State University, USA; Ph.D - Indian Institute of Technology Madras, India",
        "AreasofInterest": "Industrial Wastewater Treatment, Solid Waste Management, Electrochemical Advanced Oxidation Techniques, Nonthermal Plasma Techniques",
        "Email": "nippatlapallice@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Narasamma.png"
    },
   
    {
        "Name": "Dr. Prasanna Kumar Behera",
        "NameLink": "https://iittp.ac.in/dr-prasanna-kumar-behera",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology Kanpur, India",
        "AreasofInterest": "Durability of concrete structures, Corrosion of reinforcing steel",
        "Email": "prasanna@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr. Prasanna Kumar Behera.png"
    },
    
    {
        "Name": "Dr. A.V. Rahul",
        "NameLink": "/dr-a-v-rahul",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Indian Institute of Technology Madras, India",
        "AreasofInterest": "Concrete 3D printing, Rheology of cement-based materials",
        "Email": "rahulav@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/rahul.jpg"
    },
    {
        "Name": "Dr. Loukham Shyamsunder",
        "NameLink": "/dr-loukham-shyamsunder",
        "Position": "Assistant Professor",
        "Degree": "Ph.D - Arizona State University, USA",
        "AreasofInterest": "Finite Element Modeling, Bio-inspired Materials",
        "Email": "sloukham@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr_Loukham_Shyamsunder_AP.png"
    },

]
const GuestFaculty = [

    {
        "Name": "Dr. Kalai Selvi",
        "NameLink": "https://iittp.ac.in/dr-b-krishna-prapoorna",
        "Position": "",
        "Category": "",
        "Degree": "Ph.D - Indian Institute of Technology, Madras, India ",
        "AreasofInterest": "Auditorium and Recording studio Acoustics, Noise control and Thermal comfort.",
        "Phone": "",
        "Email": "kalai@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/kalaiselvi.jpg"
    }

]

function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="CIVIL & ENVIRONMENTAL ENGINEERING" />
            <section className="team-area fix p-relative pt-120 pb-80">
                 
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 p-relative">
                            <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                
                                <h3>CIVIL & ENVIRONMENTAL ENGINEERING</h3>
                            </div>
                        </div>
                    </div>


                    <Row>
                        <Col md={3} className='c-left custom-padding-color mb-4'>
                            <DeptLeft activeIndex={3} />
                        </Col>
                        <Col md={9} className='c-right'>

                            {/*--------------------------- Head of the dept */}

                            <div className="row justify-content-center">
                                <h3 className='c-headline mt-5 mb-5'>Head of the Department</h3>
                                {HD.map((HD, index) => (
                                    <div key={index} className="col-xl-5 col-md-6">
                                        {/* 
                                {index === 0 || HD.Category !== HD[index - 1].Category ? (
                                    <div>
                                        <h5 className="font-weight-bold text-teal">{HD.Category}</h5>
                                        <hr/> <br/>
                                    </div>
                                ) : null} */}

                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={HD.NameLink}>
                                                        <img src={HD.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={HD.NameLink}>{HD.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{HD.Position}</p>
                                                    <p className="text-dark">{HD.Degree}</p>
                                                    <p className="text-dark"><b>Areas of Interest:</b> {HD.AreasofInterest}</p>

                                                    {(HD.Phone !== undefined && HD.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{HD.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i> Email : {HD.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {/*--------------------------- Faculty*/}
                            <div className="row">
                                <h3 className='c-headline mt-5 mb-5'>Faculty</h3>
                                {Faculty.map((Faculty, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={Faculty.NameLink}>
                                                        <img src={Faculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={Faculty.NameLink}>{Faculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{Faculty.Position}</p>
                                                    <p className="text-dark">{Faculty.Degree}</p>
                                                    <p className="text-dark"><b>Areas of Interest:</b> {Faculty.AreasofInterest}</p>

                                                    {(Faculty.Phone !== undefined && Faculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{Faculty.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i> Email : {Faculty.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>



                            {/*--------------------------- Guest Faculty*/}
                            <div className="row">
                                <h3 className='c-headline mt-5 mb-5'>Guest Faculty</h3>
                                {GuestFaculty.map((GuestFaculty, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={GuestFaculty.NameLink}>
                                                        <img src={GuestFaculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={GuestFaculty.NameLink}>{GuestFaculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{GuestFaculty.Position}</p>
                                                    <p className="text-dark">{GuestFaculty.Degree}</p>
                                                    <p className="text-dark"><b>Areas of Interest:</b> {GuestFaculty.AreasofInterest}</p>

                                                    {(GuestFaculty.Phone !== undefined && GuestFaculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{GuestFaculty.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i> Email : {GuestFaculty.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>
        </>
    )
}

// // Function to parse HTML content and extract text
// function parseHTML(htmlString) {
//     const tempElement = document.createElement('div');
//     tempElement.innerHTML = htmlString;
//     return tempElement.textContent || tempElement.innerHTML || '';
// }


export default Main